/**
 * Team grid — random order on load, plus filtering by team.
 * The "all" tab and the recruitment CTA card are always visible.
 */

// Mirrors the $palette in team-grid.php.
const PALETTE = ['c1', 'c2', 'c3', 'c4'];

/**
 * Shuffle the member cards so the roster reads differently on every visit.
 *
 * Markup order stays alphabetical (by surname, via menu_order) so the page is
 * deterministic without JS; only the rendered order is randomised. The CTA card
 * keeps its slot, and the colour rhythm is positional in the template, so it is
 * re-applied afterwards rather than travelling with the cards.
 */
const shuffleMembers = (section) => {
  const grid = section.querySelector('.team-grid__grid');

  if (!grid) return;

  const nodes = Array.from(grid.children);
  const slots = [];
  const members = [];

  nodes.forEach((node, index) => {
    if (node.hasAttribute('data-team-ids')) {
      slots.push(index);
      members.push(node);
    }
  });

  if (members.length < 3) return;

  for (let i = members.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [members[i], members[j]] = [members[j], members[i]];
  }

  const ordered = nodes.slice();
  slots.forEach((slot, i) => {
    ordered[slot] = members[i];
  });
  ordered.forEach((node) => grid.appendChild(node));

  members.forEach((node, i) => {
    PALETTE.forEach((colour) =>
      node.classList.remove(`team-grid__card--${colour}`)
    );
    node.classList.add(`team-grid__card--${PALETTE[i % PALETTE.length]}`);
  });
};

const initTeamGrid = (section) => {
  shuffleMembers(section);

  const tabs = Array.from(section.querySelectorAll('[data-team-filter]'));
  const cards = Array.from(section.querySelectorAll('[data-team-ids]'));

  if (!tabs.length || !cards.length) {
    return;
  }

  const activate = (filter) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.teamFilter === filter;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    cards.forEach((card) => {
      const ids = card.dataset.teamIds ? card.dataset.teamIds.split(' ') : [];
      const show = filter === 'all' || ids.includes(filter);
      card.hidden = !show;
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => activate(tab.dataset.teamFilter));
  });
};

const initAll = () => {
  document.querySelectorAll('[data-team-grid]').forEach((section) => {
    if (section.dataset.teamGridInitialized) {
      return;
    }

    section.dataset.teamGridInitialized = 'true';
    initTeamGrid(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
